import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");

    window.history.replaceState(null, "", window.location.pathname);

    if (error) {
      navigate("/login", { replace: true, state: { error } });
      return;
    }

    (async () => {
      try {
        const user = await api.me();
        setUser(user);
        navigate("/", { replace: true });
      } catch (e) {
        const status = e?.response?.status;
        if (status === 403) {
          navigate("/login", { replace: true, state: { error: "This app is private." } });
        } else {
          navigate("/login", { replace: true, state: { error: "Sign in failed. Try again." } });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-zinc-900 flex items-center justify-center">
      <p className="text-zinc-400 text-sm">Signing you in…</p>
    </div>
  );
}
